import { render } from "./DetailDiscount.vue?vue&type=template&id=6b9fba9f&scoped=true"
import script from "./DetailDiscount.vue?vue&type=script&lang=js"
export * from "./DetailDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9fba9f"]])

export default __exports__